import React from 'react';
import { TextField } from '@material-ui/core';

const Input = props => {
  return (
    <TextField
      size="small"
      name={props.input.name}
      label={props.label}
      variant="outlined"
      defaultValue={props.input.value}
      onChange={props.onChange}
      inputProps={{ ...props.input }}
      error={props.meta.submitFailed && !props.meta.valid} // срабатывает по ходу ввода после неудачной отправки
    />
  );
};

export default Input;
